import { Chip, IconButton } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../stateManagement/store";
import { infoOff, infoOn, selectInfo } from "../../stateManagement/infoSlice";
import InfoIcon from '@mui/icons-material/Info';

const InfoToggleButton: React.FC = () => {

    const dispatch = useDispatch<AppDispatch>();

    const infoState = useSelector(selectInfo);

    return (
        infoState ?
            <Chip
                label="close"
                onClick={() => dispatch(infoOff())}
                onDelete={() => dispatch(infoOff())}
                deleteIcon={<InfoIcon />}
                variant="filled"
                color='success'
            />
            :
            <IconButton
                size="small"
                color={infoState ? 'secondary' : 'inherit'}
                onClick={() => dispatch(infoOn())}
            >
                <InfoIcon />
            </IconButton>
    )
};

export default InfoToggleButton;